import Vue from 'vue';
import firebase from '@/Firebase.js';
import FirebasePt from '@/config/FirebaseTraducaoPt.js';
import Firestore from '@/Firestore.js';
import Firestorage from '@/Firestorage.js';
import * as firebaseAPP from 'firebase/app';
import 'firebase/auth';
import Store from '@/store';

import CookieManager from '@/utils/cookieManager.js';

export default {
  login(email, password) {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (response) => {
        sessionStorage.clear();
        const uidUser = await response.user.uid;

        let user = await this.getUserFirebaseByUid(uidUser);
        delete user.admin;

        return user;
      })
      .catch((error) => {
        let errorMessage = FirebasePt[error.code] ? FirebasePt[error.code] : error.message;
        throw Error(errorMessage);
      });
  },

  async loginOidcCopel(user) {
    sessionStorage.clear();
    const uidUser = user.uid;
    user = await this.getUserFirebaseByUid(uidUser);
    delete user.admin;
    return user;
  },

  async getUserFirebaseByUid(uid) {
    return Firestore.collection('usuarios')
      .doc(uid)
      .get()
      .then(async (doc) => {
        return {
          id_hexa: null,
          uid: uid,
          nome: doc.data().nome || '',
          sobrenome: doc.data().sobrenome || '',
          email: doc.data().email || '',
          admin: doc.data().admin || false,
          desativado: doc.data().desativado || false,
          profile_picture: (await this.getUserProfilePictureByUid(uid)) || ''
        };
      })
      .catch((error) => {
        const msg = `Erro ao resgatar informações de usuário: ${error}`;
        console.error(msg);
        throw Error(msg);
      });
  },

  async getUserProfilePictureByUid(uid) {
    const pathReference = Firestorage.ref(`usuarios/profile_pictures/${uid}.jpeg`);

    return pathReference
      .getDownloadURL()
      .then((url) => url)
      .catch((error) => {
        if (error.code !== 'storage/object-not-found') {
          /* storage/object-not-found == nenhum objeto na referência encontrado, evita que apareça o erro($toast) caso o usuario não possuir foto de perfil */
          console.error('Erro ao carregar foto de perfil: ', error);
        }
      });
  },

  logout() {
    return new Promise((resolve, reject) => {
      firebaseAPP
        .auth()
        .signOut()
        .then(() => {
          /* Limpa os canais ativos do pusher */
          Vue.prototype.$pusher.unbind();

          /* Limpa os tour's em execução caso exista */

          /* Expira o JWT do Cookie */
          if (process.env.VUE_APP_API_BASE_URL === 'production') {
            CookieManager.createCookie('_jwt', '0', 1, 'Strict', true, '.gestaohexa.com.br');
          } else {
            CookieManager.createCookie('_jwt', '0', 1, 'Strict', true);
          }

          /* Limpa o VUEX */
          Store.dispatch('resetUserModule');
          Store.dispatch('resetUserIsAdminModule');
          Store.dispatch('resetEmpresaModule');
          Store.dispatch('resetTipoListaConsultaModule');

          /* 
          NÃO RETIRAR ESSE RELOAD, Ao finalizar o logout o popup do tawk-to não some, a unica forma e com reload(), tentei
          pesquisar metodos alternativos, inclusive no arquivo hexa-tawk.js eu criei um prototype function com o nome endTawk 
          para tentar criar essa funcionalidade hardcode porem o som de notificação fica com problema apos relogar depois de 
          um logout, não encontrei solução...
        */
          location.reload();

          resolve(true);
        })
        .catch((error) => reject(error));
    });
  },

  async userIsAdmin() {
    let isAdmin = false;
    try {
      const userInfo = await this.getUserFirebaseByUid(Store.getters.getUserUid);
      isAdmin = userInfo.admin;
    } catch (e) {
      console.log(e);
    }
    return isAdmin;
  }
};
